import React from 'react';
import { Upload24, Area24, Star24 } from '@carbon/icons-react';
import { FullHeaderLeftSideFullPanelLayout } from 'layouts/fullHeader.LeftSideFullPanel.layout';
import { APP_URL } from 'types';
import FeatureCard from './components/FeatureCard';

const PREMIUM_FEATURE_CARDS = [
  {
    title: 'Large area enquiries',
    description:
      'Upload a geospatial file to lodge multiple enquiries in a single submission. Supports GeoJSON, GeoPackage, KMZ, SHP, and TAB formats with up to 1,000 features per lodgement.',
    tags: ['GeoJSON, GeoPackage, KMZ, Shapefile, TAB', 'Up to 1,000 features'],
    ctaLabel: 'Start large area enquiries',
    to: APP_URL.BULK_ENQUIRY_LODGEMENT,
    icon: <Upload24 />,
    iconModifierClass: 'premium-self-service__feature-card-icon--blue'
  },
  {
    title: 'BYDA member lookup',
    description:
      'Identify all referral members whose assets intersect a defined area of interest. Upload a geospatial file or draw a polygon directly on the map. Export results as CSV.',
    tags: ['Draw on map or upload file', 'CSV export'],
    ctaLabel: 'Start member lookup',
    to: APP_URL.BYDA_MEMBER_LOOKUP,
    icon: <Area24 />,
    iconModifierClass: 'premium-self-service__feature-card-icon--orange'
  },
  {
    title: 'Purchase API or web query transactions',
    description: 'Create or top up transactions to your account.',
    tags: ['For developers'],
    ctaLabel: 'Purchase transactions',
    to: APP_URL.PURCHASE_TRANSACTIONS,
    icon: <Star24 />,
    iconModifierClass: 'premium-self-service__feature-card-icon--purple'
  }
];

const PremiumSelfService: React.FC = () => {
  return (
    <div className="premium-self-service" data-testid="premiumSelfService">
      <FullHeaderLeftSideFullPanelLayout
        pageHeading="Premium features"
        pageDescription="Advanced services for BYDA users. Select a feature below to get started."
        enableHeaderGlobalBar={true}
      >
        <div className="premium-self-service__nav-cards">
          <div className="premium-self-service__card-grid">
            {PREMIUM_FEATURE_CARDS.map((feature) => (
              <FeatureCard key={feature.to} {...feature} />
            ))}
          </div>
        </div>
      </FullHeaderLeftSideFullPanelLayout>
    </div>
  );
};

export default PremiumSelfService;
